import React from 'react';
import AnnouncementList from '../../../pages/AnnouncementPage/AnnouncementList';



function DashAnnouncement() {

    return (

        <>
           

              
                    <div className="card shadow ">
                        <div className='card-header'>
                        <h6 class="text-violet text-start">Announcement</h6>
                        </div>
                    
                        <div className='card-body'>
                        <AnnouncementList/>
                          
                   
                        </div>
                    </div>
              

        </>
    );
}

export default DashAnnouncement;






























